import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import {
  HeaderBannerRail,
  MegaMenuBar,
  MenuLink,
  MobileNav,
  StoreLogo,
} from '@/features/storefront/layouts/chrome/ChromeParts';
import { menuItems, type HeaderProps } from '@/features/storefront/layouts/chrome/types';
import { cn } from '@/lib/cn';

/** One quiet row. No border, small type, the page starts almost immediately. */
export const Header: FC<HeaderProps> = ({ storeName, logoUrl, header, menu, endSlot, preview }) => {
  const items = menuItems(menu);
  return (
    <header
      className={cn(header.sticky && !preview && 'sticky top-0 z-40')}
      style={{ backgroundColor: 'var(--storefront-background)' }}
    >
      <HeaderBannerRail header={header} preview={preview} />
      <StorefrontContainer className="flex min-h-14 items-center justify-between gap-6 py-2">
        <div className="flex min-w-0 items-center gap-3">
          <MobileNav menu={menu} hiddenFrom="sm:hidden" preview={preview} />
          <StoreLogo
            storeName={storeName}
            logoUrl={logoUrl}
            logoWidthPx={header.logo_width_px}
            showStoreName={header.show_store_name}
            preview={preview}
            nameClassName="text-sm font-semibold tracking-tight"
          />
        </div>
        <div className="flex min-w-0 items-center gap-6">
          {items.length > 0 ? (
            <nav aria-label={menu?.name} className="hidden items-center gap-6 sm:flex">
              {items.map((item) => (
                <MenuLink
                  key={`${item.label}:${item.url}`}
                  item={item}
                  preview={preview}
                  className="text-sm hover:opacity-70"
                  />
              ))}
            </nav>
          ) : null}
          <div className="flex shrink-0 items-center gap-5">{endSlot}</div>
        </div>
      </StorefrontContainer>
      <MegaMenuBar header={header} preview={preview} />
    </header>
  );
};
